<span
  class="badge {{ type }} {{ !!icon ? 'badge--with-icon' : '' }}"
  [style.maxWidth]="maxBadgeWidth"
  [title]="text"
>
  <capra-icon
    *ngIf="icon"
    [icon]="icon"
  ></capra-icon>
  <span>
    {{ text }}
  </span>
</span>
